<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="球杆绑定"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-form @submit="onBatchSubmit">
        <!-- 批量球杆列表 -->
        <div v-for="(item, index) in batchFormList" :key="index" class="batch-item">
          <div class="batch-item-header">
            <span class="header-span">球杆 {{ index + 1 }}</span>
            <van-icon
                name="cross"
                class="delete-icon"
                @click="deleteBatchItem(index)"
                v-if="batchFormList.length > 1"
            />
          </div>

          <!-- 球杆编号 -->
          <van-field
              v-model="item.number"
              name="number"
              label="球杆编码"
              placeholder="请输入球杆编码"
              :rules="[{ required: true }]"
          />

          <!-- 球杆品牌 -->
          <van-field
              readonly
              clickable
              name="brand"
              :value="item.brand"
              label="球杆品牌"
              placeholder="点击选择球杆品牌"
              @click="openBrandSelectDialog(index)"
              class="search-input"
              :rules="[{ required: true }]"
          />
          <van-popup v-model="showBrandPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="selectOptions"
                @confirm="onBrandConfirm"
                @cancel="showBrandPicker = false"
            />
          </van-popup>

          <!-- 球杆型号 -->
          <van-field
              readonly
              clickable
              name="model"
              :value="item.model"
              label="球杆型号"
              placeholder="点击选择球杆型号"
              @click="openModelSelectDialog(index)"
              class="search-input"
              :rules="[{ required: true }]"
          />
          <van-popup v-model="showModelPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="selectModelOptions"
                @confirm="onModelConfirm"
                @cancel="showModelPicker = false"
            />
          </van-popup>

          <!-- 购买渠道 -->
          <van-field
              v-model="item.channel"
              name="channel"
              label="购买渠道"
              placeholder="请输入购买渠道"
              :rules="[{ required: true }]"
          />

          <!-- 购买价格 -->
          <van-field
              v-model="item.price"
              name="price"
              label="购买价格"
              placeholder="请输入购买价格"
              type="number"
              :rules="[{ required: true }]"
          />

          <!-- 购买时间 -->
          <van-field
              readonly
              clickable
              name="startTime"
              :value="item.startTime"
              label="购买时间"
              placeholder="点击选择购买时间"
              :rules="[{ required: true }]"
              @click="() => openCalendar(index)"
          />
          <van-datetime-picker
              v-if="showCalendar"
              v-model="currentDate"
              type="date"
              title="选择年月日"
              @confirm="onConfirm"
          />

          <!-- 销售人员选择弹窗 -->
          <van-popup v-model="showSalesPicker" position="bottom" :style="{ height: '60%' }">
            <!-- 搜索框 -->
            <div style="padding: 15px; border-bottom: 1px solid #eee;">
              <van-search
                  v-model="salesSearch"
                  placeholder="搜索销售人员"
                  @input="onSalesSearch"
              />
            </div>
            <!-- 选择列表 -->
            <van-picker
                :columns="salesColumns"
                show-toolbar
                @confirm="onSalesConfirm"
                @cancel="showSalesPicker = false"
            />
          </van-popup>

          <!-- 购买凭证 -->
          <van-field
              class="checktype-img"
              name="fileList"
              label="购买凭证"
              :rules="[{ required: true, message: '请上传购买凭证' }]"
          >
            <template #input>
              <van-uploader v-model="item.fileList" multiple :max-count="3" />
            </template>
          </van-field>

          <!-- 销售人员 -->
          <van-field
              readonly
              clickable
              :value="item.salesUserName"
              name="salesUserId"
              label="销售人员"
              placeholder="选择销售人员（选填）"
              @click="openSalesSelectDialog(index)"
          />
        </div>

        <!-- 添加新球杆按钮 -->
        <div style="margin: 16px;" v-if="!isBind">
          <van-button
              class="add-item-btn"
              round
              block
              type="default"
              @click="addBatchItem"
          >
            添加新球杆
          </van-button>
        </div>

        <!-- 批量提交按钮 -->
        <div style="margin: 16px;">
          <van-button class="submit-btn" round block type="info" native-type="submit">{{isBind?'绑定':'批量绑定'}}</van-button>
        </div>

      </van-form>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {Dialog} from "vant";
import {brandDropDown, relation, salesService} from "@/api/sales";

export default {
  data(){
    return {

      // 批量表单数据列表
      batchFormList: [
        {
          number: '',
          brand: '',
          brandCode: '',
          model: '',
          modelCode: '',
          channel: '',
          price: '',
          startTime: '',
          fileList: [],
          salesUserId: '',
          salesUserName: ''
        }
      ],

      //购买时间日历组件是否显示
      showCalendar: false,
      currentDate: new Date(), // 初始设置为当前日期和时间
      targetIndex: 0,         // 批量表单的目标索引

      //球杆品牌
      selectBrandDrop: [],    // 品牌下拉数据源
      showBrandPicker: false,
      selectOptions: [],

      //球杆型号
      showModelPicker: false,
      selectModelOptions: [],

      isBind: false,

      // 销售人员相关
      showSalesPicker: false,
      salesSearch: '',
      salesList: [],
      salesColumns: []
    }
  },
  created() {
    this.selectBrandDropDown();
    //从我的球杆页面跳转进来的
    if(this.$route.query.number){
      this.batchFormList[0].number =this.$route.query.number;

      this.isBind = true;
    }

  },
  methods: {
    //获取品牌、系列下拉数据
    async selectBrandDropDown(){
      try {
        const response = await brandDropDown();
        if(response.code===200){
          this.selectBrandDrop = response.data;
        }
      } catch (error) {
        console.error("获取产品失败:", error);
      }
    },
    //品牌点击事件
    openBrandSelectDialog(index){
      this.targetIndex = index;
      this.showBrandPicker = true;
      this.selectOptions = this.selectBrandDrop.map(item=>({
        text: item.value,
        value: item.label
      }));
    },
    //品牌确认事件
    onBrandConfirm(value, index){
      const selectedItem = this.selectOptions[index];
      const target = this.getTargetForm();

      if (target) {
        if(target.brandCode!== selectedItem.value){
          target.model = '';
        }
        target.brandCode = selectedItem.value;
        target.brand = selectedItem.text;
      }

      this.showBrandPicker = false;
    },
    //型号点击事件
    openModelSelectDialog(index){
      this.targetIndex = index;
      const target = this.getTargetForm();
      console.log(245,target);

      if (!target?.brandCode) {
        this.showDialogMsg("请先选择球杆品牌");
        return;
      }
      this.showModelPicker = true;
      this.selectModelOptions = this.selectBrandDrop
          .find(parent => parent.label === target.brandCode)
          ?.children.map(child => ({ text: child.value, value: child.label })) ?? [];
    },
    //型号确认事件
    onModelConfirm(value, index){
      const selectedItem = this.selectModelOptions[index];
      const target = this.getTargetForm();

      if (target) {
        target.modelCode = selectedItem.value;
        target.model = selectedItem.text;
      }
      this.showModelPicker = false;
    },

    // 打开日期选择器
    openCalendar(index) {
      console.log(347,index);
      this.targetIndex = index;
      this.showCalendar = true;
    },

    //购买日期日历组件确认事件
    onConfirm(date) {
      const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      console.log(354,formattedDate);
      const target = this.getTargetForm();

      console.log(357,target);
      if (target) {
        target.startTime = formattedDate;
      }
      this.showCalendar = false;
    },

    // 获取目标表单对象
    getTargetForm() {
        return this.batchFormList[this.targetIndex];
    },

    //顶部标题栏返回事件
    onClickLeft() {
      // this.$router.push('/app_home');
      this.$router.go(-1);
    },
    //提示语
    showDialogMsg(message){
      Dialog.alert({
        title: '提示',
        message: message,
      });
    },

    // 添加新的批量表单条目
    addBatchItem() {
      this.batchFormList.push({
        number: '',
        brand: '',
        brandCode: '',
        model: '',
        modelCode: '',
        channel: '',
        price: '',
        startTime: '',
        fileList: [],
        salesUserId: '',
        salesUserName: ''
      });
    },

    // 获取销售人员列表
    async getSalesList(keyWord = '') {
      try {
        const res = await salesService(keyWord);
        if (res.code === 200) {
          this.salesList = res.data || [];
          this.salesColumns = this.salesList.map(item => ({
            text: item.nickName || '',
            value: item.id || ''
          }));
        }
      } catch (error) {
        console.error('获取销售人员列表失败:', error);
      }
    },

    // 搜索销售人员
    onSalesSearch() {
      this.getSalesList(this.salesSearch);
    },

    // 打开销售人员选择弹窗
    openSalesSelectDialog(index) {
      this.targetIndex = index;
      this.salesSearch = '';
      this.getSalesList();
      this.showSalesPicker = true;
    },

    // 确认选择销售人员
    onSalesConfirm(value, index) {
      const salesUserId = typeof value === 'object' && value !== null ? value.value : value;
      const target = this.getTargetForm();
      
      if (target) {
        target.salesUserId = salesUserId;
        target.salesUserName = this.salesColumns[index]?.text || '';
      }
      
      this.showSalesPicker = false;
    },

    // 删除批量表单条目
    deleteBatchItem(index) {

      Dialog.confirm({
        title: '提示',
        message: '确认要删除球杆'+(index+1)+'吗？',
      })
          .then(() => {
            this.batchFormList.splice(index, 1);
          })
    },

    //球杆激活提交
    async onBatchSubmit(){
      const formData = new FormData();
      this.batchFormList.forEach((item, index) => {
        // 格式：productList[索引].属性名
        formData.append(`productList[${index}].number`, item.number); // 球杆编号
        formData.append(`productList[${index}].brand`, item.brand); // 品牌
        formData.append(`productList[${index}].model`, item.model); // 型号
        formData.append(`productList[${index}].brandCode`, item.brandCode); // 品牌
        formData.append(`productList[${index}].modelCode`, item.modelCode); // 型号
        formData.append(`productList[${index}].channel`, item.channel); // 购买渠道（值）
        formData.append(`productList[${index}].price`, item.price); // 价格
        formData.append(`productList[${index}].startTime`, item.startTime); // 购买时间
        formData.append(`productList[${index}].salesUserId`, item.salesUserId); // 销售人员ID

        const fileList = item.fileList; // 关键修改4：正确获取当前表单项的文件列表
        const key = item.number.trim();
        if (Array.isArray(fileList) && fileList.length > 0) {
          fileList.forEach(file => {
            if (file.file) { // 确保原生文件对象存在
              formData.append(key, file.file);
            }
          });
        }
      });

      const res = await relation(formData)
      if (res.code === 200) {
        this.showDialogMsg(res.returnMsg);
      } else {
        this.showDialogMsg(res.returnMsg);
      }
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .van-field{
  @media (min-width: 768px) {
    margin-bottom: 20px !important;
  }
}
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
}
.top-bar{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}
.container-item {
  margin-bottom: 60px;
}
.submit-btn{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
}

// 批量样式
.batch-item {
  //margin-bottom: 20px;
  padding: 10px;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 15px;
  @media (min-width: 768px) {
    margin: 10px 15px;
    padding: 20px 50px;
  }

  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-weight: bold;
    @media (min-width: 768px) {
      margin: 15px;
    }
  }

  .delete-icon {
    color: #f56c6c;
    font-size: 16px;
  }
}
.header-span{
  font-size: 16px;
  color: #222;
  @media (min-width: 768px) {
    font-size: 30px;
  }
}
.add-item-btn {
  border: 1px dashed #ccc;
  color: #666;
}
// ################### 核心修复：PC端预览图超界问题 ###################
.checktype-img {
  @media (min-width: 768px) {
    // 1. 基础容器适配：保证高度+不溢出
    min-height: 150px !important;
    height: auto !important;
    padding: 10px 0 !important;
    overflow: visible !important;

    // 2. 字段内容区适配
    ::v-deep .van-field__control {
      height: auto !important;
      min-height: 130px;
      padding: 0 !important;
      width: 100% !important; // 强制占满容器宽度
      box-sizing: border-box !important;
    }

    // 3. Uploader容器：横向滚动+尺寸控制（核心解决超界）
    ::v-deep .van-uploader {
      width: 100% !important;
      padding: 10px 0;
      display: flex !important;
      flex-wrap: nowrap !important; // 强制单行
      overflow-x: auto !important; // 横向滚动，不超界
      overflow-y: hidden !important;
      gap: 10px !important; // 统一间距，替代margin
      box-sizing: border-box !important;
      scrollbar-width: thin; // 美化滚动条（Firefox）

      // 滚动条样式优化（Chrome/Safari）
      &::-webkit-scrollbar {
        height: 6px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #D4AF37;
        border-radius: 3px;
      }

      // 4. 上传按钮：缩小尺寸适配容器
      .van-uploader__upload {
        width: 100px !important;
        height: 100px !important;
        flex-shrink: 0 !important; // 禁止压缩
        margin: 0 !important; // 取消margin，用gap控制间距
        font-size: 14px !important;
      }

      // 5. 预览图：缩小尺寸+禁止压缩
      .van-uploader__preview {
        width: 100px !important;
        height: 100px !important;
        flex-shrink: 0 !important; // 禁止压缩，避免变形
        margin: 0 !important; // 取消margin，用gap控制间距
        position: relative;
      }
      .van-uploader__preview-image{
        width: 100px !important;
        height: 100px !important;
      }

      // 6. 预览图删除按钮：适配缩小后的预览图
      .van-uploader__preview-delete {
        width: 20px !important;
        height: 20px !important;
        font-size: 12px !important;
        top: 5px;
        right: 5px;
      }
    }
  }
}

// 移动端保持原有逻辑（不影响）
::v-deep .van-uploader {
  @media (max-width: 767px) {
    flex-wrap: wrap !important;
    overflow-x: visible !important;
  }
}
// ###########################################################
</style>